module.exports = __webpack_public_path__ + "media/images/fond-atable-9e600042a8a82a6ca9325884a8ebd33c.png";